// extracted by mini-css-extract-plugin
export var actions = "_1y-0";
export var actionsContainer = "_1y-7";
export var border = "_1y-1";
export var childFullHeight = "_1y-f";
export var collapse = "_1y-2";
export var content = "_1y-a";
export var contentChild = "_1y-e";
export var fullscreen = "_1y-c";
export var hasLeftRadius = "_1y-k";
export var headerContainer = "_1y-3";
export var headerRow = "_1y-5";
export var hidePadding = "_1y-b";
export var navCollapsedGap = "_1y-l";
export var noScrollX = "_1y-m";
export var noScrollY = "_1y-n";
export var noTopPadding = "_1y-i";
export var optOutTopPadding = "_1y-d";
export var pageMain = "_1y-j";
export var pageOuter = "_1y-g";
export var pagePadding = "_1y-8";
export var pageScroll = "_1y-9";
export var profile = "_1y-o";
export var profileContainer = "_1y-p";
export var profileImage = "_1y-q";
export var profileMain = "_1y-r";
export var profileSubtitle = "_1y-t";
export var profileTitle = "_1y-s";
export var showLeftPadding = "_1y-h";
export var tabsPortalSlot = "_1y-6";
export var tabsWrapper = "_1y-4";
export var title = "_1y-u";